export enum ServiceNowFiltersOptions {
    Date = 'Date',
}
